export default __webpack_public_path__ + "formulario1.jpg";